module.exports = __webpack_public_path__ + "19f8dad54b1a69026b4656eb34509c98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/guinness_atkinson.png
// module id = 1676
// module chunks = 0